// AskingForm.js
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { API_IP } from "../../env";

// Accept 'show' and 'onHide' props
function AskingForm({
  show,
  onHide,
  providerID,
  providerName,
  setRefreshProvider,
  refreshProvider,
}) {
  async function axiosReqConfig(url, method, data) {
    // ... (axiosReqConfig is the same)
    const bearerToken = localStorage.getItem("@uphealth_login_token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: data,
    };
    const returnData = await axios(reqConfig);
    console.log(returnData);
    return returnData;
  }

  async function removeAProvider() {
    await axiosReqConfig(`${API_IP}/api/admin/providers`, "delete", {
      provider_id: providerID,
    }); //
    setRefreshProvider(!refreshProvider);
    onHide(); // Use onHide to close
  }

  // Use the 'show' and 'onHide' props on the Modal component
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Discard Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Do you really want to remove this provider:{" "}
          <span className="fw-bold">{providerName}</span>
        </p>
        <p className="text-danger fw-bold">
          ALERT: You cannot undo this process.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="danger" onClick={removeAProvider}>
          YES, REMOVE
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AskingForm;
